<template>
  <div>
    <v-chip v-if="(!addresses || addresses.length === 0) && (!address || address.length === 0)" dark>{{ lang.customers.datatable.no_address_ }}</v-chip>
    <div v-else>
      <v-chip v-if="!(addresses) && (address)" dark class="addressCard">
        {{ `${address.address} ${address.num} ${(address.comp !== '' ? '(' + address.comp + ')' : '' )}` }}<br />
        {{ `${address.neighborhood}`}}<br />
        {{ `${address.city}/${address.state} - ${cepMask(address.cep)}` }}<br />
      </v-chip>
      <v-chip v-else v-for="(address, index) in addresses.slice().reverse().slice(0, 1)" :key="index" dark class="addressCard">
        {{ `${address.address} ${address.num} ${(address.comp !== '' ? '(' + address.comp + ')' : '' )}` }}<br />
        {{ `${address.neighborhood}`}}<br />
        {{ `${address.city}/${address.state} - ${cepMask(address.cep)}` }}<br />
      </v-chip>
    </div>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  name: 'addressCard',
  mixins: [ appdata, utils ],
  props: {
    addresses: {
      type: Array,
      required: false
    },
    address: {
      type: Object,
      required: false
    }
  }
}
</script>

<style>
.addressCard {
  font-size: 12px !important;
  height: 65px !important;
  line-height: 17px !important;
}
</style>
